import { useState } from 'react';
import { Alert } from '@acp/core-ui';
import { Button, Text } from '@chakra-ui/react';
import { useLogout, useSession } from '@acp/feature/auth';
import { CardLayout } from './card-layout';

const showImpersonationWarning = import.meta.env.VITE_PUBLIC_SHOW_IMPERSONATION_WARNING === '1';
const isImpersonationMutationsBlocked = import.meta.env.VITE_PUBLIC_IMPERSONATION_MUTATIONS_BLOCKED === '1';

function ImpersonationWarning() {
    const [isDismissed, setIsDismissed] = useState(false);
    const { handleLogout } = useLogout();
    const {
        complianceSystemUrl,
        isImpersonating,
    } = useSession();

    if (isDismissed || !isImpersonating || !showImpersonationWarning) {
        return null;
    }

    return (
        <CardLayout bgColor="transparent" px={0} py={0}>
            <Alert
                status="info"
                title="You are currently viewing the compliance portal as another user"
                aside={(
                    <>
                        <Button variant="link" size="sm" colorScheme="info" onClick={() => setIsDismissed(true)}>Dismiss</Button>
                        <Button
                            ml={4}
                            size="sm"
                            colorScheme="info"
                            onClick={() => handleLogout(`${complianceSystemUrl}/App/switchBackToOriginalUser`)}
                        >
                            Switch back
                        </Button>
                    </>
                )}
            >
                {
                    isImpersonationMutationsBlocked && (
                        <Text>
                            Please note that you can not make any changes
                            to this agencies data for the duration of this session.
                        </Text>
                    )
                }
                {
                    !isImpersonationMutationsBlocked && (
                        <Text>
                            Please note that any changes made during this
                            session will be reflected in agency data.
                        </Text>
                    )
                }
            </Alert>
        </CardLayout>
    );
}

export { ImpersonationWarning };
